 
import { fbqAddScript, fbqSetupTracking } from 'utils/analytics/fbq';
import { useConsentRestrictedScripts } from 'hooks/useConsentRestrictedScripts';
import AppSettings from 'settings/AppSettings';
import React from 'react';

export const FacebookPixel: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { consentLevelAdvertising, scriptAdded, setScriptAdded } = useConsentRestrictedScripts();

  // Load script
  React.useEffect(() => {
    if (consentLevelAdvertising) {
      if (!scriptAdded) {
        fbqAddScript();
        fbqSetupTracking(AppSettings.FACEBOOK_PIXEL_ID);
        setScriptAdded(true);
      }
      if (window.fbq) {
        window.fbq('consent', 'grant');
      }
    } else {
      if (window.fbq) {
        window.fbq('consent', 'revoke');
      }
    }
  }, [consentLevelAdvertising, scriptAdded, setScriptAdded]);

  return null;
};
